import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Roadmap from './components/Roadmap';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <Roadmap />,
  document.querySelector('#form-content')
);